import { render, staticRenderFns } from "./reportdetail.vue?vue&type=template&id=1c98d888&scoped=true&"
import script from "./reportdetail.vue?vue&type=script&lang=js&"
export * from "./reportdetail.vue?vue&type=script&lang=js&"
import style0 from "./reportdetail.vue?vue&type=style&index=0&id=1c98d888&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c98d888",
  null
  
)

export default component.exports